import { render, staticRenderFns } from "./BoxAndDiceIntegration.vue?vue&type=template&id=6c8aa16a&scoped=true&"
import script from "./BoxAndDiceIntegration.vue?vue&type=script&lang=js&"
export * from "./BoxAndDiceIntegration.vue?vue&type=script&lang=js&"
import style0 from "./BoxAndDiceIntegration.vue?vue&type=style&index=0&id=6c8aa16a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8aa16a",
  null
  
)

export default component.exports